import { render, staticRenderFns } from "./Ubigeo.vue?vue&type=template&id=5ffe19d1"
import script from "./Ubigeo.vue?vue&type=script&lang=js"
export * from "./Ubigeo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports